
"use client";

import { useEffect, useRef, useState } from "react";
import { getCookie } from "typescript-cookie";
import { Card, CardBody } from "@heroui/card";
import { GetUser, UserObj } from "./acount/AcountBar";
import { Spinner } from "@heroui/spinner";



export default function VncViewer2() {

  const [websocket, setWebsocket] = useState<WebSocket>();
  const [ActualUser, SetActualUser] = useState<UserObj>(new UserObj);
  const screenRef = useRef<HTMLDivElement | null>(null);
  const rfbRef = useRef<any>(null);
  
  const cursorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {

    let mounted = true;
    
    async function initVnc() {
      console.log("Loading noVNC module...");

      //try {
      const RFB  = (await import(  "@novnc/novnc/lib/rfb"  )).default;

      const rfb = new RFB(
        screenRef.current,
        "wss://supetajnypristupkamilamoravceaurcitesheslem.stolz.work/api/socket/websockify?IP=10.5.0.8&PORT=6080"
        //websocket
      );
      rfb.showDotCursor = true;
      rfb.localCursor = true;

      rfb.scaleViewport = true;
      rfb.resizeSession = true;

      rfbRef.current = rfb;
    };

    initVnc();

    return () => {
      mounted = false;
      rfbRef.current?.disconnect();
      rfbRef.current = null;
    };
  }, []);
  
  
  return (
    <>
      {
     // ActualUser.type >= 0?
      <div style={{}} className="h-full" onTouchStart={() => keyboardRef.current?.focus()}>
        <div ref={screenRef} style={{  zIndex :2, 
              width: "100%", 
              height: "100%", 
              backgroundColor: "transparent", 
              visibility:"visible", 
              cursor: "auto",
              outline: "none",
              }}/>
      </div>
      }
    </>
  )
};
